import React from "react";

const TableButton = ({
  type,
  onClick,
  label,
  className,
  disabled,
  icon,
  iconPosition = "start",
  referance,
  onKeyDown,
  tooltip,
}) => {
  return (
    <button
      type={type || "button"}
      onClick={onClick}
      disabled={disabled}
      title={tooltip}
      className={
        !disabled
          ? `${className} flex items-center justify-center rounded-md  transition-all duration-200 hover:bg-opacity-90 text-xs min-w-[28px] h-7`
          : "rounded-md text-xs bg-gray-300 text-gray-500 flex items-center justify-center  cursor-not-allowed min-w-[28px] h-7"
      }
      ref={referance}
      onKeyDown={onKeyDown}
    >
      {icon && iconPosition === "start" && (
        <span className={label ? "mr-1" : ""}>{icon}</span>
      )}

      {label && <span className="whitespace-nowrap">{label}</span>}

      {icon && iconPosition === "end" && <span className="ml-1">{icon}</span>}
    </button>
  );
};

export default TableButton;
